// extracted by mini-css-extract-plugin
export default {"container":"page-banner_container__vMN9a","image_wrapper":"page-banner_image_wrapper__ae-e8"};